require("flexslider");
var AOS = require("aos");
require("./jquery.jfontsize-1.0");
require('./jquery.fancybox.pack');
import fullpage from './fullpage';

/**
 * Details/summary HTML element
 * Only open one element at a time
 */

jQuery(document).ready(function ($) {
  $(window).on('load', function () {
    /**
     * Details/summary HTML element
     * Only open one element at a time
     */
    if (document.querySelector('details')) {
      // Fetch all the details elements
      const details = document.querySelectorAll('details');

      // Add onclick listeners
      details.forEach((targetDetail) => {
        targetDetail.addEventListener("click", () => {
          // Close all details that are not targetDetail
          details.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.removeAttribute("open");
            }
          });
        });
      });
    }


    /* Portrait or landscap */
    if( $('.view-diaporama').length > 0 ){
      function portraitOrLandscape(){
        var windowSize = $(window).width()/$(window).height();
        if( windowSize > 1.78 ){
          $('.portrait').removeClass('portrait');
          $('.view-diaporama .slides li img').addClass('landscape');
        }else{
          $('.landscape').removeClass('landscape');
          $('.view-diaporama .slides li img').addClass('portrait');
        }
      }
      portraitOrLandscape();
      jQuery(window).resize(function () {
        portraitOrLandscape();
      });
    }
    /* Change actialite HP background image after click on pager */
    if( $('.home-actuality').length > 0 ){
      (function($, Drupal, drupalSettings) {

        Drupal.behaviors.actualite = {

          attach: function(context, settings) {

            $(document).ajaxSuccess(function (event, data) {

                if (drupalSettings && drupalSettings.views && drupalSettings.views.ajaxViews) {

                var ajaxViews = drupalSettings.views.ajaxViews;

                let codeExecuted = false;
                Object.keys(ajaxViews || {}).forEach(function (i) {

                  if (ajaxViews[i]['view_name'] == 'actualites' &&  ajaxViews[i]['view_display_id'] == 'home' && !codeExecuted){
                    var imgUrl = $('.home-actuality img').attr('src');
                    $('.general-info-bg').css("background-image", "url(" + imgUrl + ")");
                    codeExecuted = true;
                  }

                });
              }
            });
          }
        };
      })(jQuery, Drupal, drupalSettings);
    }


    /* Actualite HP */

    if( $(window).width() >= 768 ){
      /* click and scroll to next slide */
      if( $('.bottom-arrow').length > 0 ){
        $('.bottom-arrow').on('click', function(){
          fullpage_api.moveSectionDown();
        });
      }
      /* Full Page */
      if( $('#fullpage').length > 0 ){
        var myFullpage = new fullpage('#fullpage', {
          scrollingSpeed: 1500,
          afterRender: function(){
            $('.home .diaporama .flexslider .slides .bloc-desc-diapo').addClass('slide-animate');
          },
          onLeave: function(origin, destination, direction, trigger){
            if( origin.index == 0 && direction == 'down'){
              $("header.home-header").addClass('sticky-header');
            }
            if(origin.index == 1 && direction == 'up'){
              $("header.home-header").removeClass('sticky-header');
            }
          },
          beforeLeave: function(origin, destination, direction, trigger){
            if( destination.index == 0 ){
              $('.home .diaporama .flexslider .slides .bloc-desc-diapo').addClass('slide-animate');
            }else{
              $('.slide-animate').removeClass('slide-animate');
            }
            if( destination.index == 1 ){
              if( direction == 'down' ){
                //$('.animate-before').removeClass('animate-before');
                $('.general-info-wrapper').addClass('animate-after');
              }
              setTimeout(function(){
                $('.general-info-wrapper').css('z-index', '2');
              }, 1500);
            }else{
              $('.general-info-wrapper').css('z-index', '0');
              if( direction == 'up' ){
                $('.animate-after').removeClass('animate-after');
                $('.general-info-wrapper').addClass('animate-before');
              }
            }
          }
        });
      }

    }
    /*Home image slider*/
    $('.diaporama .flexslider').flexslider({
      animation: "slide",
      slideshowSpeed: 5000,
      animationSpeed: 2000,
      directionNav: true,
      prevText: "",
      nextText: "",
      manualControls: ".flex-control-nav li",
      animationLoop: false,
      touch: false,
      maxItems: 1,
      start: function (slider) {
        //$('.diaporama .flexslider').removeClass('loading');
        $('.loading-home').removeClass('loading-home');
        stickyPagination();
        if (slider.currentSlide == 0) {
          slider.pause();
          setTimeout(function () {
            slider.play();
          }, 668);
        }
        // slider.directionNav = flase;
        if (slider.count == 1) {
          $('.diaporama .flex-direction-nav').addClass('hide');
        }
      },
      after: function (slider) {
        if (slider.currentSlide == 0) {
          slider.pause();
          setTimeout(function () {
            slider.play();
          }, 662);
        }
      }
    });
    $('#block-navigationsecondaire li:first-child').find('a').text('');
    $('#block-navigationsecondaire li:first-child').find('a').attr('title', 'présence dans le monde');
    $('#block-navigationsecondaire--2 li:first-child').find('a').text('');
    $('#block-navigationsecondaire--2 li:first-child').find('a').attr('title', 'présence dans le monde');


    $('.activities-tabs li:first-child a').addClass("active");
    $('.activities-tabs a').on('click', function () {
      $('.activities-tabs a').removeClass('active');
      $(this).addClass('active');
    });

    $('.medias-flexslider.flexslider').flexslider({
      animation: "slide",
      itemWidth: 300,
      itemMargin: 18,
      minItems: 1,
      move: 1,
      maxItems: getGridSize(),
      controlNav: true,
      // animationLoop:true,
      start: function (slider) {
        slides_count = slider.count;

        //initial progress bar width
        // progress_bar_width = (curSlide+1)*slider.vars.maxItems*(100 / slider.count );
        // $('.slider-progress-bar-full').width(progress_bar_width+'%');


        // $('.medias-flexslider .flex-nav-prev').addClass('disable');
        // $('.medias-flexslider .flex-nav-next').removeClass('disable');

      },
      // after: function(slider) {
      //     curSlide = slider.currentSlide;
      //     if( curSlide == 0){
      //         $('.medias-flexslider .flex-nav-prev').addClass('disable');
      //     }else{
      //         $('.medias-flexslider .flex-nav-prev').removeClass('disable');
      //     }
      //
      //     var temp = (curSlide + 1)*slider.vars.maxItems  - slides_count;
      //     console.log(temp);
      //     if(  temp < slider.vars.maxItems &&  0 <= temp ){
      //         $('.medias-flexslider .flex-nav-next').addClass('disable');
      //     }else{
      //         $('.medias-flexslider .flex-nav-next').removeClass('disable');
      //     }
      //
      //
      //     //update progress bar
      //     progress_bar_width = (curSlide+1)*slider.vars.maxItems*(100 / slider.count );
      //     $('.slider-progress-bar-full').width(progress_bar_width+'%');
      // },
      // end: function(slider){
      //
      // }
    });

    $('.toggle-menu').on('click', function () {
      $(this).toggleClass('opened');
      $(this).parent().find('> a').toggleClass('opened');
      $(this).next().slideToggle();
    });
    // $('.file-upload').
  });

  jQuery(document).ready(function () {



    //tabs
    $('.tab_content').hide();
    $('.tab_content:first').show();
    $('.tabs li:first').addClass('active');
    $('.tabs li').click(function (event) {
      $('.tabs li').removeClass('active');
      $(this).addClass('active');
      $('.tab_content').hide();

      var selectTab = $(this).find('a').attr("href");

      $(selectTab).fadeIn();
      return false;
    });

    //mines map
    $(".point").click(function () {
      $(".popup").removeClass("active");
      var target = $(this).attr("href");
      $(target).addClass("active");
    }, function () {

    });
    $(".mine-title").click(function () {
      $(".mines-titles li").removeClass("active");
      $(".mine-title").removeClass("active");
      $(".popup").removeClass("active");
      $(".map-links .point").removeClass("active");
      $(".actif-production-content").removeClass("active");

      $(this).addClass("active");
      $(this).parent("li").addClass("active");

      var target = $(this).attr("href");
      $('.map-links [href="' + target + '"]').parent('.point').addClass('active');
      $(target).addClass("active");

      return false;
    });
    $(".lien-plus").click(function () {
      $(".actif-production-content").removeClass("active");
      var target = $(this).attr("href");
      $(target).addClass("active");
      $('html,body').animate({
        scrollTop: $(target).offset().top - 115
      }, 1500);
      return false;
    });

    //animations
    AOS.init({
      once: false,
      duration: 0
    });

    //print
    $(".print").click(function () {
      window.print();
    });

    //scroll to ID
    $('.activities-tabs a[href^="#"]').on('click', function (event) {
      var target = $(this.getAttribute('href'));
      if (target.length) {
        event.preventDefault();
        $('html, body').stop().animate({
          scrollTop: target.offset().top - 191
        }, 1000);
      }
    });

    $('html, body').jfontsize({
      btnMinusClasseId: '#jfontsize-m2', // Defines the class or id of the decrease button
      btnDefaultClasseId: '#jfontsize-d2', // Defines the class or id of default size button
      btnPlusClasseId: '#jfontsize-p2', // Defines the class or id of the increase button
      btnMinusMaxHits: 3, // How many times the size can be decreased
      btnPlusMaxHits: 5, // How many times the size can be increased
      sizeChange: 2 // Defines the range of change in pixels
    });

    /*$(".icone-metal").not(':first').hover(
      function () {
        $(".item-metal:first-child .bg-metal").css("opacity", "0");
      },
      function () {
        $(".item-metal:first-child .bg-metal").css("opacity", "1");
      }
    );
    //traitement sur cuivre
    $('.item-metal:nth-child(2) .icone-metal').hover(
      function () {
        $('.item-metal:nth-child(6) .icone-metal').css("background", "#40403F");
      },
      function () {
        $('.item-metal:nth-child(6) .icone-metal').css({
          "background": "rgba(64, 64, 63, 0.5)"
        });
      }
    );
    $('.item-metal:nth-child(6) .icone-metal').hover(
      function () {
        $('.item-metal:nth-child(6) .icone-metal').css("background", "#40403F");
      },
      function () {
        $('.item-metal:nth-child(6) .icone-metal').css({
          "background": "rgba(64, 64, 63, 0.5)"
        });
      }
    );

    //traitement sur plomb
    $('.item-metal:nth-child(6) .icone-metal').hover(
      function () {
        $('.item-metal:nth-child(2) .icone-metal').css("background", "#40403F");
      },
      function () {
        $('.item-metal:nth-child(2) .icone-metal').css({
          "background": "rgba(64, 64, 63, 0.5)"
        });
      }
    );
    $('.item-metal:nth-child(2) .icone-metal').hover(
      function () {
        $('.item-metal:nth-child(2) .icone-metal').css("background", "#40403F");
      },
      function () {
        $('.item-metal:nth-child(2) .icone-metal').css({
          "background": "rgba(64, 64, 63, 0.5)"
        });
      }
    );*/
    //language
    //var value = $('.region-secondary-menu .block-language ul.links a.is-active').text();
    var value = $('#block-selecteurdelangue ul.links a[hreflang="' + drupalSettings.path.currentLanguage  + '"]').text();
    $('.selected-language').text(value);
    $(".block-language ul.links .is-active").click(function () {
      var value = $('.block-language ul.links a.is-active').text();
      $('.selected-language').text(value);
    });
    $(".block-language").click(function () {
      $(this).find('.links').toggle();
    });

    //Search
    $('.menu-top .block-search').click(function () {
      if (!$('.form-search').hasClass("hover") || !$('.form-submit').hasClass("hover")) {
        $('.form-search').addClass("hover");
        $('.form-submit').addClass("hover");
      } else {
        if ($('.form-search').is(":focus")) {
          $('.form-search')
            .keyup(function () {
              $('.form-submit').css('z-index', 2);
            });
        } else {
          $('.form-search').removeClass("hover");
          $('.form-submit').removeClass("hover");
        }
      }
    });
    $('.region-primary-menu .block-search').click(function () {
      if (!$('.form-search').hasClass("hover") || !$('.form-submit').hasClass("hover")) {
        $('.form-search').addClass("hover");
        $('.form-submit').addClass("hover");
      } else {
        if ($('.form-search').is(":focus")) {
          $('.form-search')
            .keyup(function () {
              $('.form-submit').css('z-index', 2);
            });
        } else {
          $('.form-search').removeClass("hover");
          $('.form-submit').removeClass("hover");
        }
      }
    });

    $('.navbar-toggle').click(function () {
      // $( '.menu-bottom' ).attr('data-aos', 'fade-down');
      $(this).toggleClass('active');
      // $( this ).parent().parent().toggleClass('wihte');
      $('.menu-bottom').toggle();
      $('.menu-bottom').toggleClass('navbar-collapse');
    });

    // Show/Read more
    $(document).on("click", ".show-more", function(e) {
      $(this).next('.bloc-description').toggleClass('show-description');
      $(this).next('.bloc-description').toggleClass('hide-description');

      if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        // $('html,body').animate({
        //     scrollTop: $(this).offset().top
        // }, 1000);
      } else {
        // $('html,body').animate({
        //     scrollTop: $(this).next('.bloc-description').offset().top - ($(this).next('.bloc-description').height())
        // }, 1000);
        $(this).addClass('open');
      }
    });
    $('.show-infos').on('click', function () {
      $(this).toggleClass('bottom');
      $('.comite-teaser').removeClass('active');
      $('.comite-details').removeClass('show-description');
      $('.comite-details').addClass('hide-description');
      if ($(this).hasClass('bottom')) {
        $(this).parent('.comite-teaser').addClass('active');
        $(this).parent('.comite-teaser').next('.comite-details').removeClass('hide-description');
        $(this).parent('.comite-teaser').next('.comite-details').addClass('show-description');
      }
    });
    $('.block-quicktabs-blockgouvernance-et-organisation .quicktabs-tabs').children('li:first-child').find('a').bind('click', function () {
      $('.block-views-blockcommite-executif-commite').removeClass('hide-block');
    });
    $('.block-quicktabs-blockgouvernance-et-organisation .quicktabs-tabs').children('li:not(:first-child)').find('a').bind('click', function () {
      $('.block-views-blockcommite-executif-commite').addClass('hide-block');
    });
    // $('.Count').each(function () {
    //     var $this = $(this);
    //     jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
    //         duration: 5000,
    //         easing: 'swing',
    //         step: function () {
    //             $this.text(Math.ceil(this.Counter));
    //         }
    //     });
    // });
    stickyPagination();

    //history view
    $('.step-title').click(function () {
      $('body .step-first-column').removeClass('active');
      $(this).parent('.step-first-column').addClass('active');
      $(this).parent('.step-first-column').find('.histroy-step').removeClass('active');
      $(this).parent('.step-first-column').find('.histroy-step').first().addClass('active');
      $('.step-details').removeClass('active');
      $(this).parent('.step-first-column').find('.histroy-step').first().find('.step-details').addClass('active');
      $('html,body').animate({
        scrollTop: $(this).parent('.step-first-column').offset().top - $(this).height() - 500
      }, 500);
    });
    $('.step-sub-title').click(function () {
      $('body .histroy-step').removeClass('active');
      $(this).parent('.histroy-step').addClass('active');
      $('.step-details').removeClass('active');
      $(this).parent('.histroy-step').find('.step-details').addClass('active');
    });

    //actif en production
    if( $(".map-description").length > 0 ){
      $description = $(".map-description");


      $('path.enabled').hover(function (e) {
        $description.addClass('active');
        $description.html($(this).attr('data'));
        $description.css({
          left: e.pageX - 377,
          top: e.pageY - 466
        });
      }, function () {
        $description.removeClass('active');
      });
    }
    // $(document).on('mousemove', function(e){
    //     console.log(e.pageX);
    //     $description.css({
    //         left:  e.pageX - 26,
    //         top:   e.pageY - 26
    //     });
    // });
    $(document).on('click', "path.enabled.clickable", function () {
      $description.addClass('active');
      $description.html($(this).attr('data'));
      $('path.enabled.clickable').removeClass('active');
      $(this).addClass('active');
      var country_selected = $(this).attr('taxonomy-id');
      var protocol_domain = window.location.href;
      var protocol_domain_arr = protocol_domain.split("/");
      var protocol_domain_val = protocol_domain_arr[0] + "//" + protocol_domain_arr[2];
      if (protocol_domain_arr[3].length == 2)
        protocol_domain_val += "/" + protocol_domain_arr[3];
      $(".default-map-summary").addClass('hide');
      $(".map-summary").html("");
      // $(".contact-loader").show();
      $.ajax({
        type: "GET",
        url: protocol_domain_val + "/ajax/actif",
        data: "country_selected=" + country_selected,
        dataType: "html",
        async: true,
        complete: function (data) {
          // $(".contact-loader").hide();
          $(".map-summary").empty().html(data.responseText);
        }
      });
      return false;
    });
    $(document).on('click', ".mines", function () {
      var nid = $(this).attr('nid');
      var protocol_domain = window.location.href;
      var protocol_domain_arr = protocol_domain.split("/");
      var protocol_domain_val = protocol_domain_arr[0] + "//" + protocol_domain_arr[2];
      if (protocol_domain_arr[3].length == 2)
        protocol_domain_val += "/" + protocol_domain_arr[3];
      $(".project-entity").html("");
      $(".mine-entity").html("");
      // $(".contact-loader").show();
      $.ajax({
        type: "GET",
        url: protocol_domain_val + "/ajax/mine",
        data: "nid=" + nid,
        dataType: "html",
        async: true,
        complete: function (data) {
          // $(".contact-loader").hide();
          $(".mine-entity").empty().html(data.responseText);
          $('html,body').animate({
            scrollTop: $(".mine-entity").offset().top - 200
          }, 10);

          document.getElementById("open-modal").style.pointerEvents = "auto";
          document.getElementById("open-modal").style.visibility = "visible" ;
          document.getElementById("open-modal").style.opacity = "1" ;
          $('.dialog-off-canvas-main-canvas').addClass('enableBlur');
        }
      });
      return false;
    });
    $(document).on('click', ".projets-en-dev", function () {
      var nid = $(this).attr('nid');
      var protocol_domain = window.location.href;
      var protocol_domain_arr = protocol_domain.split("/");
      var protocol_domain_val = protocol_domain_arr[0] + "//" + protocol_domain_arr[2];
      if (protocol_domain_arr[3].length == 2)
        protocol_domain_val += "/" + protocol_domain_arr[3];
      $(".mine-entity").html("");
      $(".project-entity").html("");
      // $(".contact-loader").show();
      $.ajax({
        type: "GET",
        url: protocol_domain_val + "/ajax/dev-project",
        data: "nid=" + nid,
        dataType: "html",
        async: true,
        complete: function (data) {
          // $(".contact-loader").hide();
          $(".project-entity").empty().html(data.responseText);
          $('html,body').animate({
            scrollTop: $(".project-entity").offset().top - 200
          }, 10);
          document.getElementById("open-modal").style.pointerEvents = "auto";
          document.getElementById("open-modal").style.visibility = "visible" ;
          document.getElementById("open-modal").style.opacity = "1" ;
          $('.dialog-off-canvas-main-canvas').addClass('enableBlur');
        }
      });
      return false;
    });

    $(document).on('click', "#close-modal", function () {
      document.getElementById("open-modal").style.pointerEvents = "none";
      document.getElementById("open-modal").style.visibility = "hidden" ;
      document.getElementById("open-modal").style.opacity = "0" ;
      $('.dialog-off-canvas-main-canvas').removeClass('enableBlur');
    });

    $(document).on('click', "body", function (e) {
      if((e.target.id === 'open-modal')) {
        document.getElementById("open-modal").style.pointerEvents = "none";
        document.getElementById("open-modal").style.visibility = "hidden" ;
        document.getElementById("open-modal").style.opacity = "0" ;
        $('.dialog-off-canvas-main-canvas').removeClass('enableBlur');
      }
    });

    $('.actif-production .views-exposed-form .js-form-submit').click(function () {
      $(".default-map-summary").addClass('hide');
      $('path.enabled.clickable').removeClass('active');
      $(".map-summary").html("");
      $(".mine-entity").html("");
      $(".project-entity").html("");
    });

    $('#play-video').click(function () {
      var myVideo = document.getElementById('diapo-video');
      var url = myVideo.getAttribute('src');
      // ?rel=0&controls=0&autoplay=1&showinfo=0
      if (myVideo.requestFullscreen) {
        myVideo.requestFullscreen();
      } else if (myVideo.msRequestFullscreen) {
        myVideo.msRequestFullscreen();
      } else if (myVideo.mozRequestFullScreen) {
        myVideo.mozRequestFullScreen();
      } else if (myVideo.webkitRequestFullScreen) {
        myVideo.webkitRequestFullScreen();
      }
      myVideo.setAttribute('src', url + '?rel=0&autoplay=1&showinfo=0');
      $('#diapo-video').removeClass('hideiframe');
      $('#diapo-video').addClass('showiframe');
    });

    // $(document).on('click', "a.album-gallery", function () {
    //     var nid = $(this).attr('nid');
    //     var protocol_domain = window.location.href;
    //     var protocol_domain_arr = protocol_domain.split("/");
    //     var protocol_domain_val = protocol_domain_arr[0] + "//" + protocol_domain_arr[2];
    //     if (protocol_domain_arr[3].length == 2)
    //         protocol_domain_val += "/" + protocol_domain_arr[3];
    //     $.ajax({
    //         type: "GET",
    //         url: protocol_domain_val+"/ajax/album-gallery",
    //         data: "nid=" + nid,
    //         dataType:"html",
    //         async: true,
    //         complete: function(data) {
    //             $(".gallery-popup").empty();
    //             $("#gallery-popup-"+nid).empty().html(data.responseText);
    //             $('.gallery-slider').flexslider({
    //                 animation: "slide"
    //             });
    //             $(this).fancybox();
    //         }
    //     });
    //     return false;
    // });
    // $("a.album-gallery").fancybox();
    $("a.album-gallery").on('click', function () {
      var nid = $(this).attr('nid');
      var protocol_domain = window.location.href;
      var protocol_domain_arr = protocol_domain.split("/");
      var protocol_domain_val = protocol_domain_arr[0] + "//" + protocol_domain_arr[2];
      if (protocol_domain_arr[3].length == 2)
          protocol_domain_val += "/" + protocol_domain_arr[3];
      $.ajax({
          type: "GET",
          url: protocol_domain_val + "/ajax/album-gallery",
          data: "nid=" + nid,
          dataType: "html",
          async: true,
          complete: function (data) {
              $(".gallery-popup").empty();
              $("#gallery-popup-" + nid).empty().html(data.responseText);
              $('.gallery-slider').flexslider({
                animation: "slide",
                controlNav: false,
                directionNav: true,
                prevText: "Previous",
                nextText: "Next",
                start: function() {
                    $('.gallery-slider').on('layoutChange', function() {
                        $(this).resize();
                    });
                }
              });
              $.fancybox.open({
                  autoSize: false,
                  src: '#gallery-popup-' + nid,
                  type: 'inline',
                  afterShow: function() {
                      $('.gallery-slider').trigger('layoutChange');
                  }
              });
          }
        });
    });
    $("a.album-video").fancybox({
      type: 'iframe'
    });

    var value = $('.block-language ul.links a.is-active').first().text();
    $('.selected-language').empty().text(value);
  });
  jQuery(window).resize(function () {
    function getGridSize() {
      if ($(window).width() < 499) {
        return 1;
      } else if ($(window).width() > 500 && $(window).width() < 1024) {
        return 2;
      } else {
        return 2;
      }
    }
    var gridSize = getGridSize();

  });


  $(window).scroll(function () {
    // sticky header
    var header = $("header.home-header");
    if ($(window).scrollTop() >= 30) {
      header.addClass('sticky-header');
    } else {
      header.removeClass('sticky-header');
    }

    stickyPagination();

  });

  function stickyPagination() {
    var diapo = jQuery(".home .diaporama .slides");
    if (diapo.length > 0) {
      var pagination = jQuery(".home .diaporama .flexslider .flexslider-controls");
      var diapo_position = diapo.offset().top + diapo.outerHeight(true);
      var windows_position = $(window).scrollTop() + $(window).height();

      if (windows_position < diapo_position) {
        pagination.addClass('sticky-pagination');
      } else {
        pagination.removeClass('sticky-pagination');
      }
    }
  }

  /*Medias flexslider*/
  var slides_count = 0;
  var curSlide = 0;
  // tiny helper function to add breakpoints
  function getGridSize() {
    if ($(window).width() < 501) {
      return 1;
    } else if ($(window).width() > 500 && $(window).width() < 1230) {
      return 2;
    } else {
      return 3;
    }
  }
  $('.gallery-interne').flexslider({
    prevText: "",
    nextText: ""
  });

});
